<template>
  <loginBase variant="agency">
    <div class="login-heading">
      <h1>欢迎登录</h1>
      <p>进入代理经营中心</p>
    </div>
    <div class="login-tabs"><span class="login-tab-static is-active">密码登录</span></div>
    <el-form class="login-form login-admin-form" @submit.native.prevent label-position="top" :hide-required-asterisk="true">
      <el-form-item label="代理账号" for="agency-account">
        <el-input id="agency-account" v-model.trim="account" autocomplete="username" placeholder="请输入代理账号" @keyup.enter.native="login" />
      </el-form-item>
      <el-form-item label="登录密码" for="agency-password">
        <el-input id="agency-password" v-model="password" type="password" show-password autocomplete="current-password" placeholder="请输入密码" @keyup.enter.native="login" />
      </el-form-item>
    </el-form>
    <el-button class="login-submit" type="primary" :loading="loading" :disabled="loading" @click="login">{{ loading ? '登录中' : '登录' }}</el-button>
  </loginBase>
</template>
<script>
import loginBase from '@/components/login/LoginShell.vue';
import menuRuntime from '@/router/menuRuntime';
import { agencyMenu } from '@/views/agency/agency-menu';
import { clearAuthSessionData, clearSnapshot } from '@/util/authSession';
import { navigateAfterLogin } from '@/util/loginNavigation';
import { eltips } from '@/util/util';
export default {
  components: {
    loginBase
  },
  data() {
    return {
      account: '',
      password: '',
      loading: false
    };
  },
  methods: {
    async login() {
      if (this.loading) return;
      if (!this.account || !this.password) return eltips('请输入账号和密码', 'error');
      this.loading = true;
      try {
        const res = await this.axios.post('/api/platform_agent/login', {
          account: this.account,
          password: this.password
        }, { handlesErrorFeedback: true });
        if (res.code !== 200) return eltips(res.msg, 'error');
        clearAuthSessionData(sessionStorage);
        clearSnapshot();
        menuRuntime.reset();
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('guardName', 'platform_agent_admin_user');
        sessionStorage.setItem('loginPage', '/agentlogin');
        sessionStorage.setItem('userinfo', JSON.stringify({
          ...res.data.user,
          nickname: res.data.user.name,
          guard_name: 'platform_agent_admin_user',
          roles: []
        }));
        menuRuntime.setBase(agencyMenu(res.data.user.level));
        if (await navigateAfterLogin(this.$router, {
          path: '/agency/overview'
        })) eltips('登录成功', 'success');
        else eltips('账号已验证，但未能打开代理后台，请重试或联系管理员', 'error');
      } catch (error) {
        eltips(error.message || '登录失败，请重试', 'error');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
